import keyBy from 'lodash/keyBy';
import { createSlice, Dispatch } from '@reduxjs/toolkit';
// utils
import axios from '../../utils/axios';
// @types
import {
    INewsState,
    IUserFilePageState,
    IUserActPageState,
    IUserNotifPageState,
} from '../../@types/news';




const initialUserFilePageState: IUserFilePageState = {
    data: [],
    isLastPage: true,
    lastKey: undefined,
    lastTimestamp: "",
    newData: [],
    newDataCount: 0,
    isCalledAPI: false,
    calledTimestamp: 0,
}
const initialUserActPageState: IUserActPageState = {
    data: [],
    isLastPage: true,
    lastKey: undefined,
    lastTimestamp: "",
    newData: [],
    newDataCount: 0,
    isCalledAPI: false,
    calledTimestamp: 0,
}
const initialUserNotifPageState: IUserNotifPageState = {
    data: [],
    isLastPage: true,
    lastKey: undefined,
    lastTimestamp: "",
    newData: [],
    newDataCount: 0,
    isCalledAPI: false,
    calledTimestamp: 0,
}



const initialState: INewsState = {
    isLoading: false,
    isProcessing: false,
    isLoadingMore: false,
    isFetching: false,
    isLoadingNew: false,
    // isEmpty: false,
    error: null,

    userFilePage: initialUserFilePageState,
    userActPage: initialUserActPageState,
    userNotifPage: initialUserNotifPageState,
    // listingPage: {
    //     data: [],
    //     pageNumber: 1,
    //     pageSize: 10,
    //     isLastPage: true,
    //     nextKey: null,
    // },
    // news: null,
    // isLastPage: true,
};


const slice = createSlice({
    name: 'news',
    initialState,
    reducers: {
        // resetState(state) {
        //     // console.log(`reset(state);`);
        //     // console.log(`initialState`)
        //     console.log(initialState)
        //     state = initialState;
        //     // console.log(`state`)
        //     console.log(state)
        // },
        resetState: () => initialState,
        startLoading(state) {
            state.isLoading = true;
        },
        startLoadingMore(state) {
            state.isLoadingMore = true;
        },
        startFetching(state) {
            state.isFetching = true;
        },
        startLoadingNew(state) {
            state.isLoadingNew = true;
        },

        // stopLoading(state){
        //     state.isLoading = false;
        // },

        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        resetError(state) {
            state.error = null;
        },
        startProcessing(state) {
            state.isProcessing = true;
        },
        stopProcessing(state) {
            state.isProcessing = false;
        },
        // getNewsListSuccess(state, action) {
        //     state.isLoading = false;
        //     state.listingPage = action.payload;
        //     // state.isLastPage = action.payload.isLastPage;
        // },

        // state.listingPage = action.payload;
        // console.log(action.payload);
        // if (Number(action.payload.pageNumber) === 1) {

        // if (!state.listingPage.isLastPage) {

        //     if (Number(state.listingPage.pageNumber) === 1) {
        //         state.listingPage.data = action.payload.data;
        //     } else {
        //         state.listingPage.pageNumber += 1;
        //         state.listingPage.data = state.listingPage.data.concat(action.payload.data);
        //     }

        //     state.listingPage.isLastPage = !action.payload.hasNext;
        //     state.listingPage.nextKey = action.payload.nextKey;
        // }







        loadUserFileSuccess(state, action) {
            state.userFilePage.data = action.payload.data;
            state.userFilePage.isCalledAPI = true;
            state.userFilePage.lastKey = action.payload.LastEvaluatedKey;
            state.userFilePage.isLastPage = action.payload.isLast;

            state.userFilePage.newData = [];
            state.userFilePage.newDataCount = 0;
            state.userFilePage.lastTimestamp = action.payload.nextTimestamp;


            state.isLoading = false;
        },
        loadMoreUserFileSuccess(state, action) {
            state.userFilePage.data = state.userFilePage.data.concat(action.payload.data);
            state.userFilePage.lastKey = action.payload.LastEvaluatedKey;
            state.userFilePage.isLastPage = action.payload.isLast;
            state.isLoadingMore = false;
            // state.isLoading = false;
        },




        fetchNewUserFileSuccess(state, action) {
            if (state.userFilePage.newData?.length)
                state.userFilePage.newData = state.userFilePage.newData.concat(action.payload.data);
            else
                state.userFilePage.newData = action.payload.data
            // console.log(action.payload.data)
            state.userFilePage.newDataCount = state.userFilePage.newData?.length || 0;
            state.userFilePage.lastTimestamp = action.payload.nextTimestamp;
            state.isFetching = false;
        },

        loadNewUserFileSuccess(state) {
            let newData;
            if (state.userFilePage.newData)
                newData = state.userFilePage.newData.concat(state.userFilePage.data)
            else
                newData = state.userFilePage.data
            state.userFilePage.data = newData;
            state.userFilePage.newData = [];
            state.userFilePage.newDataCount = 0;
            state.isLoadingNew = false;
        },








        loadUserActSuccess(state, action) {
            state.userActPage.data = action.payload.data;
            state.userActPage.isCalledAPI = true;
            state.userActPage.lastKey = action.payload.LastEvaluatedKey;
            state.userActPage.isLastPage = action.payload.isLast;

            state.userActPage.newData = [];
            state.userActPage.newDataCount = 0;
            state.userActPage.lastTimestamp = action.payload.nextTimestamp;


            state.isLoading = false;
        },
        loadMoreUserActSuccess(state, action) {
            state.userActPage.data = state.userActPage.data.concat(action.payload.data);
            state.userActPage.isCalledAPI = true;
            state.userActPage.lastKey = action.payload.LastEvaluatedKey;
            state.userActPage.isLastPage = action.payload.isLast;
            state.isLoadingMore = false;
            // state.isLoading = false;
        },





        fetchNewUserActSuccess(state, action) {
            if (state.userActPage.newData?.length)
                state.userActPage.newData = state.userActPage.newData.concat(action.payload.data);
            else
                state.userActPage.newData = action.payload.data
            // console.log(action.payload.data)
            state.userActPage.newDataCount = state.userActPage.newData?.length || 0;
            state.userActPage.lastTimestamp = action.payload.nextTimestamp;
            state.isFetching = false;
        },

        loadNewUserActSuccess(state) {
            let newData;
            if (state.userActPage.newData)
                newData = state.userActPage.newData.concat(state.userActPage.data)
            else
                newData = state.userActPage.data
            state.userActPage.data = newData;
            state.userActPage.newData = [];
            state.userActPage.newDataCount = 0;
            state.isLoadingNew = false;
        },















        loadUserNotifSuccess(state, action) {
            state.userNotifPage.data = action.payload.data;
            state.userNotifPage.isCalledAPI = true;
            state.userNotifPage.newData = [];
            state.userNotifPage.newDataCount = 0;
            state.userNotifPage.lastKey = action.payload.LastEvaluatedKey;
            state.userNotifPage.lastTimestamp = action.payload.nextTimestamp;
            state.userNotifPage.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        loadMoreUserNotifSuccess(state, action) {
            state.userNotifPage.data = state.userNotifPage.data.concat(action.payload.data);
            state.userNotifPage.lastKey = action.payload.LastEvaluatedKey;
            // state.userNotifPage.lastTimestamp = action.payload.nextTimestamp;
            state.userNotifPage.isLastPage = action.payload.isLast;
            // state.isLoading = false;
            state.isLoadingMore = false;
        },






        fetchNewUserNotifSuccess(state, action) {
            // const newData = action.payload.data.concat(state.userNotifPage.data)
            // state.userNotifPage.data = newData;
            if (state.userNotifPage.newData?.length)
                state.userNotifPage.newData = state.userNotifPage.newData.concat(action.payload.data);
            else
                state.userNotifPage.newData = action.payload.data
            // console.log(action.payload.data)
            state.userNotifPage.newDataCount = state.userNotifPage.newData?.length || 0;
            state.userNotifPage.lastTimestamp = action.payload.nextTimestamp;
            // state.postsPage.lastKey = action.payload.LastEvaluatedKey;
            // state.postsPage.isLastPage = action.payload.isLast;
            state.isFetching = false;
            // state.isLoading = false;
        },

        loadNewUserNotifSuccess(state) {
            let newData;
            if (state.userNotifPage.newData)
                newData = state.userNotifPage.newData.concat(state.userNotifPage.data)
            else
                newData = state.userNotifPage.data
            state.userNotifPage.data = newData;
            state.userNotifPage.newData = [];
            state.userNotifPage.newDataCount = 0;
            state.isLoadingNew = false;
            // state.isLoading = false;
        },

        // getNewsSuccess(state, action) {
        //     state.isLoading = false;
        //     state.news = action.payload;
        // },



        deleteUserNotifSuccess(state, action) {
            // if (state.post)
            //     state.post.isLike = false;

            const userNotifId = action.payload.userNotifId;
// 
            // // console.log(`userNotifId : ${userNotifId}`);



            if (state.userNotifPage) {
                const dataList = state.userNotifPage.data;
                const dataIndex = dataList.findIndex(item => item.userNotifId === userNotifId)
                if (dataIndex !== undefined && dataIndex > -1) {
                    dataList.splice(dataIndex, 1);
                    state.userNotifPage.data = dataList;
                }

            }

            state.isProcessing = false;
        },


    }
});



// Reducer
export default slice.reducer;

export const {
    // resetState,
    startLoading,
    hasError,
    resetError,
    // startProcessing,
    // stopProcessing,

} = slice.actions;


/*
export function getNewsList(page_number: number, page_size = 10, next_key?: any | undefined) {

    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('/news', {
                params: { page_size, page_number, next_key }
            });
            dispatch(slice.actions.getNewsListSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}
*/

export function resetState() {
    // console.log("Reset State")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetState());
    }

}

export function loadUserFile() {
    // console.log(`Load User File`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('/userfile');
            dispatch(slice.actions.loadUserFileSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadMoreUserFile(nextKey: any) {
    // console.log(`Load More User File`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get('/userfile', {
                params: {
                    lastKey: nextKey,
                }
            });
            dispatch(slice.actions.loadMoreUserFileSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}







export function fetchNewUserFile(lastTimestamp: string) {
    // console.log(`Fetch New User File`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startFetching());
        try {
            const response = await axios.get('/userfile', {
                params: {
                    lastTimestamp,
                }
            });
            dispatch(slice.actions.fetchNewUserFileSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadNewUserFile() {
    // console.log(`Load User File`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingNew());
        try {
            dispatch(slice.actions.loadNewUserFileSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}









export function loadUserAct() {
    // console.log(`Load User Act`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('/activity');
            dispatch(slice.actions.loadUserActSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}



export function loadMoreUserAct(nextKey: any) {
    // console.log(`Load More User Act`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get('/activity', {
                params: {
                    lastKey: nextKey,
                }
            });
            dispatch(slice.actions.loadMoreUserActSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}










export function fetchNewUserAct(lastTimestamp: string) {
    // console.log(`Fetch New User Act`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startFetching());
        try {
            const response = await axios.get('/activity', {
                params: {
                    lastTimestamp,
                }
            });
            dispatch(slice.actions.fetchNewUserActSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadNewUserAct() {
    // console.log(`Load New User Act`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingNew());
        try {
            dispatch(slice.actions.loadNewUserActSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}
























export function deleteUserNotif(userNotifId: string, userNotifSK: string) {
    // console.log(`Delete User Notif`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.delete(`/delete-notification/${userNotifSK}`);

            dispatch(slice.actions.deleteUserNotifSuccess({ userNotifId }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}





export function loadUserNotif() {
    // console.log(`Load User Notif`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {

            // // console.log('Loading user notif;')


            const response = await axios.get('/notification');
            dispatch(slice.actions.loadUserNotifSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadMoreUserNotif(nextKey: any) {
    // console.log(`Load More User Notif`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get('/notification', {
                params: {
                    lastKey: nextKey,
                }
            });
            dispatch(slice.actions.loadMoreUserNotifSuccess(response.data));
            // console.log(response.data);
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function fetchNewUserNotif(lastTimestamp: string) {
    // console.log(`Fetch New User Notif`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startFetching());
        try {
            const response = await axios.get('/notification', {
                params: {
                    lastTimestamp,
                }
            });
            dispatch(slice.actions.fetchNewUserNotifSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadNewUserNotif() {
    // console.log(`Load New User Notif`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingNew());
        try {
            dispatch(slice.actions.loadNewUserNotifSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}